(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'prop-types', 'react'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('prop-types'), require('react'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.propTypes, global.react);
    global.MLIcons = mod.exports;
  }
})(this, function (exports, _propTypes, _react) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _react2 = _interopRequireDefault(_react);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var icons = {
    add_to_course: _react2.default.createElement(
      'g',
      { id: 'icon/add_to_course', fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement('path', { d: 'M3,5 L3,3 L21,3 L21,5 L3,5 Z M3,10 L3,8 L21,8 L21,10 L3,10 Z M3,15 L3,13 L11,13 L11,15 L3,15 Z M3,20 L3,18 L11,18 L11,20 L3,20 Z M16,16 L16,13 L18,13 L18,16 L21,16 L21,18 L18,18 L18,21 L16,21 L16,18 L13,18 L13,16 L16,16 Z', fill: '#686868' })
    ),
    alarm_clock: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M12 4.46a8.56 8.56 0 10.06 17.12A8.56 8.56 0 0012 4.46zm0 15A6.42 6.42 0 1118.45 13 6.43 6.43 0 0112 19.44v.02zM13.04 12V8h-2v6h6v-2h-4zM7.8 3.89A2.455 2.455 0 004 7l3.8-3.11zm11.81-.36a2.44 2.44 0 00-3.43.36L20 7a2.44 2.44 0 00-.39-3.47z' })
    ),
    alert_outline: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('rect', { x: '11', y: '10', width: '2', height: '4' }),
      _react2.default.createElement('rect', { x: '11', y: '15', width: '2', height: '2' }),
      _react2.default.createElement('path', { d: 'M21.71,19.13,13.06,3.85A1.31,1.31,0,0,0,12,3.08a1.31,1.31,0,0,0-1.08.77L2.26,19.13c-.59,1-.11,1.87,1.08,1.87H20.63C21.82,21,22.3,20.15,21.71,19.13ZM4.63,19,12,6l7.35,13Z' })
    ),
    alert: _react2.default.createElement('path', { d: 'M21.71,19.13,13.06,3.85a1.14,1.14,0,0,0-2.16,0L2.26,19.13c-.59,1-.11,1.87,1.08,1.87H20.63C21.82,21,22.3,20.15,21.71,19.13ZM13,17H11V15h2Zm0-3H11V10h2Z' }),
    align_adjust: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('rect', { x: '3', y: '3', width: '18', height: '3' }),
      _react2.default.createElement('rect', { x: '3', y: '8', width: '18', height: '3' }),
      _react2.default.createElement('rect', { x: '3', y: '13', width: '18', height: '3' }),
      _react2.default.createElement('rect', { x: '3', y: '18', width: '18', height: '3' })
    ),
    align_center: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('rect', { x: '3', y: '3', width: '18', height: '3' }),
      _react2.default.createElement('rect', { x: '5', y: '8', width: '14', height: '3' }),
      _react2.default.createElement('rect', { x: '7', y: '13', width: '10', height: '3' }),
      _react2.default.createElement('rect', { x: '9', y: '18', width: '6', height: '3' })
    ),
    align_left: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('rect', { x: '3', y: '3', width: '18', height: '3' }),
      _react2.default.createElement('rect', { x: '3', y: '8', width: '15', height: '3' }),
      _react2.default.createElement('rect', { x: '3', y: '13', width: '12', height: '3' }),
      _react2.default.createElement('rect', { x: '3', y: '18', width: '9', height: '3' })
    ),
    align_right: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('rect', { x: '3', y: '3', width: '18', height: '3' }),
      _react2.default.createElement('rect', { x: '6', y: '8', width: '15', height: '3' }),
      _react2.default.createElement('rect', { x: '9', y: '13', width: '12', height: '3' }),
      _react2.default.createElement('rect', { x: '12', y: '18', width: '9', height: '3' })
    ),
    arrow_up: _react2.default.createElement('polygon', { points: '21.9 11.9 12 2 2.1 11.9 3.52 13.31 11 5.83 11 21 13 21 13 5.83 20.48 13.31 21.9 11.9' }),
    arrow_down: _react2.default.createElement('polygon', { points: '21.8994 12.1006 12.0004 21.9996 2.1004 12.1006 3.5144 10.6866 11.0004 18.1716 11.0004 2.9996 13.0004 2.9996 13.0004 18.1716 20.4854 10.6866' }),
    arrow_left: _react2.default.createElement('polygon', { points: '21 11 5.84 11 13.33 3.52 11.92 2.1 3.43 10.59 3.43 10.59 2.02 12 3.43 13.41 11.92 21.9 13.33 20.48 5.84 13 21 13 21 11' }),
    arrow_right: _react2.default.createElement('polygon', { points: '3.02 11 18.17 11 10.68 3.52 12.1 2.1 20.58 10.59 20.58 10.59 22 12 20.58 13.41 12.1 21.9 10.68 20.48 18.17 13 3.02 13 3.02 11' }),
    bar_chart: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('rect', { x: '16', y: '3', width: '4', height: '18' }),
      _react2.default.createElement('rect', { x: '10', y: '9', width: '4', height: '12' }),
      _react2.default.createElement('rect', { x: '4', y: '14', width: '4', height: '7' })
    ),
    bold: _react2.default.createElement('path', { d: 'M17.64,4.79a4.31,4.31,0,0,1,.78,2.6,3.8,3.8,0,0,1-.78,2.5,4,4,0,0,1-1.3,1,3.82,3.82,0,0,1,2,1.51A4.37,4.37,0,0,1,19,14.89a5,5,0,0,1-.76,2.71A4.56,4.56,0,0,1,17,18.94a4.7,4.7,0,0,1-1.92.86,12.15,12.15,0,0,1-2.41.23H5V3h8.23Q16.35,3,17.64,4.79ZM8.4,5.93V9.69h4.14a3.33,3.33,0,0,0,1.8-.43A1.59,1.59,0,0,0,15,7.77,1.53,1.53,0,0,0,14.1,6.2a6.16,6.16,0,0,0-2-.27Zm0,6.57V17h4.13a3.89,3.89,0,0,0,1.72-.3,2.13,2.13,0,0,0,1.12-2.12,1.83,1.83,0,0,0-1.08-1.83,4.29,4.29,0,0,0-1.7-.29Z' }),
    book: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M7,2H5.05A1,1,0,0,0,4,3V21a1,1,0,0,0,1.05,1H7Z' }),
      _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('rect', { x: '11', y: '7', width: '6', height: '2' }),
        _react2.default.createElement('path', { d: 'M20,2H8V22H20Zm-2,8H10V6h8Z' })
      )
    ),
    bookmark_outline: _react2.default.createElement('path', { d: 'M17,2H6.94A1,1,0,0,0,6,3V22l6-3,6,3V3A1,1,0,0,0,17,2ZM16,18.74l-3.1-1.55L12,16.74l-.86.44L8,18.76V4h8Z' }),
    bookmark: _react2.default.createElement('path', { d: 'M17,2H6.94A1,1,0,0,0,6,3V22l6-3,6,3V3A1,1,0,0,0,17,2Z', fillRule: 'evenodd' }),
    box: _react2.default.createElement('path', { d: 'M4,20H20V9H4Zm4-8h8v2H8ZM3,4V8H21V4Z', fillRule: 'evenodd' }),
    bus: _react2.default.createElement('path', {
      d: 'M20.27 7h-.2V5a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v2a.92.92 0 0 0-.92.92v2.16A.92.92 0 0 0 4 11v6.44a1.59 1.59 0 0 0 1 1.46V20a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h8v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1.09a1.57 1.57 0 0 0 1.05-1.47V11h.2a.75.75 0 0 0 .75-.75v-2.5a.75.75 0 0 0-.73-.75zM6.05 6a1 1 0 0 1 1-1H17a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1zM7 16.35A1.34 1.34 0 1 1 8.38 15 1.34 1.34 0 0 1 7 16.35zm10-2.67A1.34 1.34 0 1 1 15.7 15a1.33 1.33 0 0 1 1.3-1.32z',
      fillRule: 'evenodd'
    }),
    calendar: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M20,4H18V2H16V4H8V2H6V4H4A1,1,0,0,0,3,5V21a1,1,0,0,0,1,1H20a1,1,0,0,0,1-1V5A1,1,0,0,0,20,4ZM5,20V10H19V20Z' }),
      _react2.default.createElement('rect', { x: '7', y: '12', width: '2', height: '2' }),
      _react2.default.createElement('rect', { x: '11', y: '12', width: '2', height: '2' }),
      _react2.default.createElement('rect', { x: '15', y: '12', width: '2', height: '2' }),
      _react2.default.createElement('rect', { x: '15', y: '16', width: '2', height: '2' }),
      _react2.default.createElement('rect', { x: '11', y: '16', width: '2', height: '2' }),
      _react2.default.createElement('rect', { x: '7', y: '16', width: '2', height: '2' })
    ),
    cancel: _react2.default.createElement('polygon', { points: '19.82 5.59 18.41 4.18 12 10.59 5.59 4.18 4.18 5.59 10.59 12 4.18 18.41 5.59 19.82 12 13.41 18.41 19.82 19.82 18.41 13.41 12 19.82 5.59' }),
    caret_down: _react2.default.createElement('polygon', { points: '2 6 12.02 18.02 22.04 6 2 6', fillRule: 'evenodd' }),
    check: _react2.default.createElement('polygon', { points: '8.42 17.96 21 5.83 19.59 4.42 7.81 15.77 3.44 11.4 2.02 12.81 6.37 17.16 6.36 17.17 7.77 18.58 7.78 18.57 7.79 18.58 8.42 17.96' }),
    checkbox: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('polygon', { points: '8.36 15.17 9.77 16.58 9.78 16.57 9.79 16.58 10.17 16.2 18 8.83 16.59 7.42 9.82 13.79 7.44 11.4 6.02 12.81 8.37 15.16 8.36 15.17' }),
      _react2.default.createElement('path', { d: 'M20,3H4A1,1,0,0,0,3,4V20a1,1,0,0,0,1,1H20a1,1,0,0,0,1-1V4A1,1,0,0,0,20,3ZM19,19H5V5H19Z' })
    ),
    chevron_down: _react2.default.createElement('polygon', { points: '20.47 6.34 11.98 14.83 3.5 6.34 2.08 7.76 11.98 17.66 13.4 16.24 21.88 7.76 20.47 6.34' }),
    chevron_left: _react2.default.createElement('polygon', { points: '17.27 3.52 15.86 2.1 7.38 10.59 7.38 10.59 5.96 12 7.38 13.41 15.86 21.9 17.27 20.48 8.79 12 17.27 3.52' }),
    chevron_right: _react2.default.createElement('polygon', { points: '16.48 10.59 16.48 10.59 8 2.1 6.59 3.52 15.07 12 6.59 20.48 8 21.9 16.48 13.41 17.9 12 16.48 10.59' }),
    chevron_up: _react2.default.createElement('polygon', { points: '12 6.34 10.59 7.76 2.1 16.24 3.52 17.66 12 9.17 20.48 17.66 21.9 16.24 12 6.34' }),
    circle_check_outline: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('polygon', { points: '10.34 13.88 7.95 11.48 6.53 12.9 8.88 15.24 8.87 15.25 10.28 16.67 10.29 16.66 10.3 16.67 10.63 16.34 17.51 9.91 16.1 8.5 10.34 13.88' }),
      _react2.default.createElement('path', { d: 'M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z' })
    ),
    circle_check: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2ZM10.3,17.17h0L6,12.9l1.42-1.42,2.89,2.9L17.1,8l1.41,1.41Z' })
    ),
    circle_chevron_left: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('circle', { stroke: 'currentColor', fill: 'none', cx: '11', cy: '11', r: '10.5' }),
      _react2.default.createElement('path', { fill: 'currentColor', d: 'M14.54 5.347L13.6 4.4 7 11l6.6 6.6.94-.947L8.887 11z' })
    ),
    circle_chevron_right: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('circle', { stroke: 'currentColor', fill: 'none', cx: '11', cy: '11', r: '10.5' }),
      _react2.default.createElement('path', { fill: 'currentColor', d: 'M8.4 4.4l-.94.947L13.113 11 7.46 16.653l.94.947L15 11z' })
    ),
    circle_empty: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M12,2 C17.523,2 22,6.478 22,12 C22,17.522 17.523,22 12,22 C6.477,22 2,17.522 2,12 C2,6.478 6.477,2 12,2 Z M12,20 C16.418,20 20,16.418 20,12 C20,7.582 16.418,4 12,4 C7.582,4 4,7.582 4,12 C4,16.418 7.582,20 12,20 Z' })
    ),
    circle_half_filled: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M10,0 C15.523,0 20,4.478 20,10 C20,15.522 15.523,20 10,20 C4.477,20 0,15.522 0,10 C0,4.478 4.477,0 10,0 Z M10,2 L10,18 C14.418,18 18,14.418 18,10 C18,5.582 14.418,2 10,2 C8.87001969,2 8.92092752,2 10,2 Z' })
    ),
    circle_full: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M2,12A10,10,0,1,0,12,2,10,10,0,0,0,2,12Z' })
    ),
    circle_lock_outline: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('circle', { className: "circle_lock_outlineIcon_innerFill", cx: 12, cy: 12, r: 9, fill: 'transparent' }),
      _react2.default.createElement('path', { d: 'M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z' }),
      _react2.default.createElement('path', { d: 'M15.45,10.4H14.2V8.2a2.2,2.2,0,0,0-4.4,0v2.2H8.55A.55.55,0,0,0,8,11v5.5a.55.55,0,0,0,.55.55h6.9a.55.55,0,0,0,.55-.55V11A.55.55,0,0,0,15.45,10.4ZM10.9,8.2a1.1,1.1,0,0,1,2.2,0v2.2H10.9Z' })
    ),
    clipboard: _react2.default.createElement('path', { d: 'M18.94,4H14.53A2.5,2.5,0,0,0,12,1.54,2.46,2.46,0,0,0,9.47,4H4.94a1,1,0,0,0-1,1V21a1,1,0,0,0,1,1h14a1,1,0,0,0,1-1V5A1,1,0,0,0,18.94,4ZM12,3a1,1,0,1,1-1,1A1,1,0,0,1,12,3Zm6,17h-12V6H8a.94.94,0,0,0,0,.1V7A1,1,0,0,0,9,8h6a1,1,0,0,0,1-1V6h1.94Z', fillRule: 'evenodd' }),
    clock: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z' }),
      _react2.default.createElement('polygon', { points: '13.04 11 13.04 6 11.04 6 11.04 11 11.04 13 13.04 13 18.04 13 18.04 11 13.04 11' })
    ),
    color: _react2.default.createElement('path', { d: 'M15,8,12,3,9,8c-1.63,2.73-3,5.18-3,7a6,6,0,0,0,12,0C18,13.18,16.63,10.73,15,8ZM11,18.51a3.74,3.74,0,0,1-2.47-3.59,10.27,10.27,0,0,1,2-5.39,8.51,8.51,0,0,0,.07,4.52c.5,1.39,1.76,1.41,2.16,2.47A1.43,1.43,0,0,1,11,18.51Z' }),
    comment_add: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M20,2H4A1,1,0,0,0,3,3V17a1,1,0,0,0,1,1H7v4l4.94-4H20a1,1,0,0,0,1-1V3A1,1,0,0,0,20,2ZM19,16H11.24L9,17.82V16H5V4H19Z' }),
      _react2.default.createElement('polygon', { points: '16 11 13 11 13 14 11 14 11 11 8 11 8 9 11 9 11 6 13 6 13 9 16 9 16 11' })
    ),
    comment_highlight: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M17,16H10.24l-.54.45L8,17.82V16H4V6h9l2-2H3A1,1,0,0,0,2,5V17a1,1,0,0,0,1,1H6v4l4.94-4H18a1,1,0,0,0,1-1V12l-2,2.13Z', fillRule: 'evenodd' }),
      _react2.default.createElement('path', { d: 'M22.43,3.73,21.26,2.54a.69.69,0,0,0-1,0l-1,1,2.08,2.17,1.05-1A.69.69,0,0,0,22.43,3.73Z', fillRule: 'evenodd' }),
      _react2.default.createElement('polygon', { points: '12.93 9.96 12.93 12.06 14.99 12.06 20.68 6.38 18.58 4.21 12.93 9.96', fillRule: 'evenodd' }),
      _react2.default.createElement('rect', { x: '6', y: '13', width: '9', height: '1' })
    ),
    comment_microphone: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M20,2H4A1,1,0,0,0,3,3V17a1,1,0,0,0,1,1H7v4l4.94-4H20a1,1,0,0,0,1-1V3A1,1,0,0,0,20,2ZM19,16H11.24l-.54.45L9,17.82V16H5V4H19Z' }),
      _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('rect', { x: '10.57', y: '5.49', width: '2.83', height: '5.52', rx: '1.41', ry: '1.41' }),
        _react2.default.createElement('path', { d: 'M15.48,9.53a.5.5,0,0,0-1,0,2.49,2.49,0,1,1-5,0,.5.5,0,0,0-1,0,3.51,3.51,0,0,0,3,3.47v1a.5.5,0,0,0,1,0V13A3.51,3.51,0,0,0,15.48,9.53Z' })
      )
    ),
    comment_question: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M20,2H4A1,1,0,0,0,3,3V17a1,1,0,0,0,1,1H7v4l4.94-4H20a1,1,0,0,0,1-1V3A1,1,0,0,0,20,2ZM19,16H11.24l-.54.45L9,17.82V16H5V4H19Z' }),
      _react2.default.createElement('path', { d: 'M11,8.08a1.35,1.35,0,0,1,.21-.45,1,1,0,0,1,.35-.31A1.08,1.08,0,0,1,12,7.2a1,1,0,0,1,.69.24A1,1,0,0,1,13,8.2a.91.91,0,0,1-.11.5,1.49,1.49,0,0,1-.3.37l-.41.33a2.8,2.8,0,0,0-.42.39A2.21,2.21,0,0,0,11.21,11v.6h1.45l0-.52a1.28,1.28,0,0,1,.22-.45,2.14,2.14,0,0,1,.39-.39l.47-.34a2.3,2.3,0,0,0,.45-.42,2.14,2.14,0,0,0,.34-.59A2.37,2.37,0,0,0,14.72,8a2,2,0,0,0-.14-.69,1.92,1.92,0,0,0-.46-.69,2.55,2.55,0,0,0-.85-.54A3.47,3.47,0,0,0,12,5.91a2.84,2.84,0,0,0-1.1.21,2.44,2.44,0,0,0-.84.57,2.61,2.61,0,0,0-.54.86,3.17,3.17,0,0,0-.2,1.1H10.9A2.25,2.25,0,0,1,11,8.08Z' }),
      _react2.default.createElement('rect', { x: '11.16', y: '12.45', width: '1.54', height: '1.56' })
    ),
    comment_text: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M20,2H4A1,1,0,0,0,3,3V17a1,1,0,0,0,1,1H7v4l4.94-4H20a1,1,0,0,0,1-1V3A1,1,0,0,0,20,2ZM19,16H11.24l-.54.45L9,17.82V16H5V4H19Z' }),
      _react2.default.createElement('rect', { x: '7', y: '7', width: '10', height: '2' }),
      _react2.default.createElement('rect', { x: '7', y: '11', width: '6', height: '2' })
    ),
    comment_thumbs_up: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M20,2H4A1,1,0,0,0,3,3V17a1,1,0,0,0,1,1H7v4l4.94-4H20a1,1,0,0,0,1-1V3A1,1,0,0,0,20,2ZM19,16H11.24l-.54.45L9,17.82V16H5V4H19Z' }),
      _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('path', { d: 'M16.52,9.05a.45.45,0,0,0-.45-.51H12.85s.46-1.27.73-2.08-.1-1.33-.59-.84L10.23,8.39a.77.77,0,0,0-.23.56v4.44a.17.17,0,0,0,.17.17H15a.79.79,0,0,0,.73-.48s.84-3,.84-3.08Z' }),
        _react2.default.createElement('rect', { x: '7.47', y: '8.56', width: '1.48', height: '4.98' })
      )
    ),
    comment: _react2.default.createElement('path', { d: 'M20,2H4A1,1,0,0,0,3,3V17a1,1,0,0,0,1,1H7v4l4.94-4H20a1,1,0,0,0,1-1V3A1,1,0,0,0,20,2ZM19,16H11.24l-.54.45L9,17.82V16H5V4H19Z' }),
    copy: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M16,4V16H4V4H16m1-2H3A1,1,0,0,0,2,3V17a1,1,0,0,0,1,1H17a1,1,0,0,0,1-1V3a1,1,0,0,0-1-1Z' }),
      _react2.default.createElement('path', { d: 'M20,9m1-2H20V20H6v1a1,1,0,0,0,1,1H21a1,1,0,0,0,1-1V8a1,1,0,0,0-1-1h0' })
    ),
    cursor: _react2.default.createElement('path', { d: 'M3,13V4A1,1,0,0,1,4,3H20a1,1,0,0,1,1,1v9l-9,7Z', fillRule: 'evenodd' }),
    cut: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M22,5s-3.42-1.21-5.48.2C15.47,6,12.44,8.49,9.9,10.69L7.3,8.92h0A3,3,0,0,0,8,7.29,3,3,0,1,0,4.72,10a1.93,1.93,0,0,0,.34,0l0,0a6.93,6.93,0,0,1,2.61,1.35l.75.66-.75.66A6.93,6.93,0,0,1,5,14l0,0a1.82,1.82,0,0,0-.33,0A3,3,0,1,0,7.31,15.1h0ZM4.83,8.79a1.8,1.8,0,1,1,2-1.62A1.79,1.79,0,0,1,4.83,8.79Zm.35,10a1.8,1.8,0,1,1,1.62-2A1.79,1.79,0,0,1,5.18,18.8Z' }),
      _react2.default.createElement('path', { d: 'M10.82,14.12c2.31,2,4.78,4,5.74,4.68C18.62,20.21,22,19,22,19l-9.18-6.28Z' })
    ),
    dock_left: _react2.default.createElement('path', { d: 'M20,3H4A1,1,0,0,0,3,4V20a1,1,0,0,0,1,1H20a1,1,0,0,0,1-1V4A1,1,0,0,0,20,3ZM19,19H9V5H19Z' }),
    dock_right: _react2.default.createElement('path', { d: 'M20,3H4A1,1,0,0,0,3,4V20a1,1,0,0,0,1,1H20a1,1,0,0,0,1-1V4A1,1,0,0,0,20,3ZM5,5H15V19H5Z' }),
    dock_top: _react2.default.createElement('path', { d: 'M20,3H4A1,1,0,0,0,3,4V20a1,1,0,0,0,1,1H20a1,1,0,0,0,1-1V4A1,1,0,0,0,20,3ZM5,19V9H19V19Z' }),
    document: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M19,2H5A1,1,0,0,0,4,3V21a1,1,0,0,0,1,1H19a1,1,0,0,0,1-1V3a1,1,0,0,0-1-1ZM6,20V4H18V20Z' }),
      _react2.default.createElement('polygon', { points: '16 7 8 7 8 9 16 9 16 7 16 7' }),
      _react2.default.createElement('polygon', { points: '16 11 8 11 8 13 16 13 16 11 16 11' }),
      _react2.default.createElement('polygon', { points: '14 15 8 15 8 17 14 17 14 15 14 15' })
    ),
    document_pencil: _react2.default.createElement('path', { fillRule: 'evenodd', d: 'M19.09 14.99l1.89 1.95-5.1 5.09h-1.85v-1.88l5.06-5.16zM19 2a1 1 0 011 1v8l-2 2V4H6v16h6v2H5a1 1 0 01-1-1V3a1 1 0 011-1zm-4.96 13v2h-6v-2h6zm7.457-1.503l.003.003 1 1.07a.62.62 0 01.003.877l-.003.003-.94.88-1.82-1.95.88-.88a.62.62 0 01.877-.003zM16.04 11v2h-8v-2h8zm0-4v2h-8V7h8z' }),
    download: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('polygon', { points: '19 14 19 18 5 18 5 14 3 14 3 18 3 20 5.5 20 19.5 20 21 20 21 18 21 14 19 14', fillRule: 'evenodd' }),
      _react2.default.createElement('polygon', { points: '12 15 16 11 13 11 13 4 11 4 11 11 8 11 12 15', fillRule: 'evenodd' })
    ),
    edit: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M20.69,5,19,3.29a1,1,0,0,0-1.41,0L16.18,4.7l3,3.13,1.51-1.41A1,1,0,0,0,20.69,5Z', fillRule: 'evenodd' }),
      _react2.default.createElement('polygon', { points: '3 17.98 3 21 5.97 21 18.17 8.82 15.14 5.68 3 17.98', fillRule: 'evenodd' })
    ),
    embed: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('polygon', { points: '8 8 4 12 8 16 8.71 15.29 5.41 12 8.71 8.71 8 8' }),
      _react2.default.createElement('polygon', { points: '16 16 20 12 16 8 15.29 8.71 18.59 12 15.29 15.29 16 16' }),
      _react2.default.createElement('polygon', { points: '3 3 3 8 5 8 5 5 19 5 19 8 21 8 21 3 3 3' }),
      _react2.default.createElement('polygon', { points: '19 19 5 19 5 16 3 16 3 21 21 21 21 16 19 16 19 19' }),
      _react2.default.createElement('polygon', { points: '13 7 10 17 11 17 14 7 13 7' })
    ),
    emoji: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z' }),
      _react2.default.createElement('path', { d: 'M15.2,13.4a4,4,0,0,1-6.4,0,1,1,0,1,0-1.6,1.2,6,6,0,0,0,9.6,0,1,1,0,1,0-1.6-1.2Z' }),
      _react2.default.createElement('circle', { cx: '14.5', cy: '9.5', r: '1.5' }),
      _react2.default.createElement('circle', { cx: '9.5', cy: '9.5', r: '1.5' })
    ),
    eraser: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('polygon', { points: '9.58 20.98 20.96 20.98 20.96 18.98 11.46 18.98 9.58 20.98' }),
      _react2.default.createElement('path', { d: 'M21.78,7.9,16.25,2.37a1.19,1.19,0,0,0-1.68,0L7.88,9.06,2.46,14.47a1.19,1.19,0,0,0,0,1.68L7.29,21h3.08l4.75-4.75,6.65-6.65A1.19,1.19,0,0,0,21.78,7.9ZM9.79,19H8.18L4.28,15.21l5-4.78L13.84,15Z' })
    ),
    expand: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M19,19H5V5h6.92l-2-2H4A1,1,0,0,0,3,4V20a1,1,0,0,0,1,1H20a1,1,0,0,0,1-1V14l-2-2Z', fillRule: 'evenodd' }),
      _react2.default.createElement('polygon', { points: '13.98 3 16.84 5.87 9.36 13.36 10.77 14.77 18.26 7.28 21 10.02 21 3 13.98 3', fillRule: 'evenodd' })
    ),
    fullscreen: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M13.66 3l3.01 2.96-3.63 3.63L14.46 11l3.64-3.64 2.94 2.89V3h-7.38M9.63 13l-3.64 3.64-2.95-2.89V21h7.38l-3.01-2.96 3.63-3.63L9.63 13M14.46 13l-1.42 1.41 3.64 3.65L13.79 21h7.25v-7.38l-2.95 3.01L14.46 13M10.29 3H3.04v7.38L6 7.37 9.63 11l1.41-1.41L7.4 5.94 10.29 3' })
    ),
    filter: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('rect', { x: '3.04', y: '4', width: '13', height: '2' }),
      _react2.default.createElement('rect', { x: '3.04', y: '11', width: '6', height: '2' }),
      _react2.default.createElement('rect', { x: '15.04', y: '11', width: '6', height: '2' }),
      _react2.default.createElement('rect', { x: '8.04', y: '18', width: '13', height: '2' }),
      _react2.default.createElement('rect', { x: '17.04', y: '3', width: '4', height: '4', rx: '1', ry: '1' }),
      _react2.default.createElement('rect', { x: '10.04', y: '10', width: '4', height: '4', rx: '1', ry: '1' }),
      _react2.default.createElement('rect', { x: '3.04', y: '17', width: '4', height: '4', rx: '1', ry: '1' })
    ),
    flag: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M10,19.58V2H9V19.6A2.44,2.44,0,0,0,7.06,22H12A2.45,2.45,0,0,0,10,19.58Z' }),
      _react2.default.createElement('path', { d: 'M16.06,2.44c-1.12.22-1.59.89-3,.89a3.45,3.45,0,0,1-2-.89V7.73a3.45,3.45,0,0,0,2,.89c1.44,0,1.86-.66,3-.87s3,.87,3,.87V3.33S17.23,2.21,16.06,2.44Z' })
    ),
    folder: _react2.default.createElement('path', { d: 'M22,20H2V5A1,1,0,0,1,3,4h7a1.09,1.09,0,0,1,1,1V6H21a1,1,0,0,1,1,1Z' }),
    grabber: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('circle', { cx: '14.03', cy: '12', r: '0.98' }),
      _react2.default.createElement('circle', { cx: '14.03', cy: '8', r: '0.98' }),
      _react2.default.createElement('circle', { cx: '14.03', cy: '4', r: '0.98' }),
      _react2.default.createElement('circle', { cx: '14.03', cy: '20', r: '0.98' }),
      _react2.default.createElement('circle', { cx: '14.03', cy: '16', r: '0.98' }),
      _react2.default.createElement('circle', { cx: '10.03', cy: '12', r: '0.98' }),
      _react2.default.createElement('circle', { cx: '10.03', cy: '8', r: '0.98' }),
      _react2.default.createElement('circle', { cx: '10.03', cy: '4', r: '0.98' }),
      _react2.default.createElement('circle', { cx: '10.03', cy: '20', r: '0.98' }),
      _react2.default.createElement('circle', { cx: '10.03', cy: '16', r: '0.98' })
    ),
    grid_4: _react2.default.createElement('path', { d: 'M3,10h7V3H3ZM14,3v7h7V3ZM3,21h7V14H3Zm11,0h7V14H14Z', fillRule: 'evenodd' }),
    grid_9: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('rect', { x: '2', y: '3', width: '5', height: '5' }),
      _react2.default.createElement('rect', { x: '9', y: '3', width: '5', height: '5' }),
      _react2.default.createElement('rect', { x: '16', y: '3', width: '5', height: '5' }),
      _react2.default.createElement('rect', { x: '2', y: '10', width: '5', height: '5' }),
      _react2.default.createElement('rect', { x: '9', y: '10', width: '5', height: '5' }),
      _react2.default.createElement('rect', { x: '16', y: '10', width: '5', height: '5' }),
      _react2.default.createElement('rect', { x: '2', y: '17', width: '5', height: '5' }),
      _react2.default.createElement('rect', { x: '9', y: '17', width: '5', height: '5' }),
      _react2.default.createElement('rect', { x: '16', y: '17', width: '5', height: '5' })
    ),
    head: _react2.default.createElement('path', { d: 'M20.6,13.32,19.07,11a1,1,0,0,1-.13-.8,6.14,6.14,0,0,0,.17-1.41C19.11,5,15.82,2,11.77,2S4.43,5,4.43,8.77c0,.12,0,.24,0,.36h0v0c0,3.27,2.14,5.75,2.6,8.46a22.13,22.13,0,0,1,0,3.3,1,1,0,0,0,1,1h4.67a1,1,0,0,0,1-1.14c-.2-2.15,2-.45,3.77-1,.84-.27,1.3-2.83,1.48-4.08a1,1,0,0,1,.77-.84l.19,0A1,1,0,0,0,20.6,13.32ZM16,8.23c-2.51,2.3-1.52,4.33-4.3,4.33s-5-1.94-5-4.33,2.26-4,5-4S17.79,6.62,16,8.23Z' }),
    header_footer: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('rect', { x: '8', y: '5', width: '8', height: '2' }),
      _react2.default.createElement('rect', { x: '8', y: '17', width: '8', height: '2' }),
      _react2.default.createElement('path', { d: 'M5,2V22H19V2ZM17,20H7V4H17Z' })
    ),
    heart_outline: _react2.default.createElement('path', { d: 'M16,4a5,5,0,0,0-4,2A5,5,0,0,0,3,9,4.52,4.52,0,0,0,4,11.9C4.61,12.66,12,20,12,20s7.32-7.14,8-8.11A4.54,4.54,0,0,0,21,9,5,5,0,0,0,16,4Zm2.42,6.71c-.41.53-3.36,3.5-6.4,6.49C8.91,14.09,5.85,11,5.49,10.61A2.59,2.59,0,0,1,5,9,3,3,0,0,1,8,6a3.5,3.5,0,0,1,2.4,1.23L12,9l1.61-1.77A3.51,3.51,0,0,1,16,6a3,3,0,0,1,3,3A2.54,2.54,0,0,1,18.43,10.71Z' }),
    heart: _react2.default.createElement('path', { d: 'M16,4a5,5,0,0,0-4,2A5,5,0,0,0,3,9,4.52,4.52,0,0,0,4,11.9C4.61,12.66,12,20,12,20s7.32-7.14,8-8.11A4.54,4.54,0,0,0,21,9,5,5,0,0,0,16,4Z' }),
    help_outline: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z' }),
      _react2.default.createElement('rect', { x: '11.05', y: '15.03', width: '1.95', height: '1.98' }),
      _react2.default.createElement('path', { d: 'M14.82,7.68A3.24,3.24,0,0,0,13.74,7a4.41,4.41,0,0,0-1.67-.27,3.61,3.61,0,0,0-1.4.26,3.11,3.11,0,0,0-1.07.72,3.31,3.31,0,0,0-.69,1.1,4,4,0,0,0-.26,1.39h2.07a2.86,2.86,0,0,1,.08-.71,1.72,1.72,0,0,1,.26-.58,1.31,1.31,0,0,1,.45-.39,1.37,1.37,0,0,1,.65-.15,1.21,1.21,0,0,1,.88.31,1.29,1.29,0,0,1,.32,1,1.15,1.15,0,0,1-.13.63,1.9,1.9,0,0,1-.39.46q-.24.21-.52.42a3.56,3.56,0,0,0-.53.5,2.81,2.81,0,0,0-.68,1.58V14H13l.06-.66a1.63,1.63,0,0,1,.28-.58,2.72,2.72,0,0,1,.5-.5l.6-.44a2.92,2.92,0,0,0,.58-.53,2.71,2.71,0,0,0,.44-.75,3,3,0,0,0,.18-1.11,2.54,2.54,0,0,0-.18-.88A2.44,2.44,0,0,0,14.82,7.68Z' })
    ),
    help: _react2.default.createElement('path', { d: 'M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm1,15h-2V15h2Zm2.4-6.46a2.71,2.71,0,0,1-.44.75,2.92,2.92,0,0,1-.58.53l-.6.44a2.72,2.72,0,0,0-.5.5,1.63,1.63,0,0,0-.28.58L13,14H11.12v-.76a2.81,2.81,0,0,1,.68-1.58,3.56,3.56,0,0,1,.53-.5q.28-.21.52-.42a1.9,1.9,0,0,0,.39-.46,1.15,1.15,0,0,0,.13-.63,1.29,1.29,0,0,0-.32-1,1.21,1.21,0,0,0-.88-.31,1.37,1.37,0,0,0-.65.15,1.31,1.31,0,0,0-.45.39,1.72,1.72,0,0,0-.26.58,2.86,2.86,0,0,0-.08.71H8.66A4,4,0,0,1,8.92,8.8a3.31,3.31,0,0,1,.69-1.1A3.11,3.11,0,0,1,10.68,7a3.61,3.61,0,0,1,1.4-.26A4.41,4.41,0,0,1,13.74,7a3.24,3.24,0,0,1,1.08.68,2.44,2.44,0,0,1,.58.88,2.54,2.54,0,0,1,.18.88A3,3,0,0,1,15.4,10.55Z' }),
    highlight: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('rect', { x: '4', y: '19', width: '16', height: '2' }),
      _react2.default.createElement('path', { d: 'M18.69,5.41a1,1,0,0,0,0-1.41L17,2.29a1,1,0,0,0-1.41,0L14.18,3.7l3,3.13Z', fillRule: 'evenodd' }),
      _react2.default.createElement('polygon', { points: '16.17 7.82 13.14 4.68 4 13.97 4 17 6.97 17 16.17 7.82', fillRule: 'evenodd' })
    ),
    home: _react2.default.createElement('polygon', { points: '20.92 12 11.94 3.02 2.96 12 5 12 5 21 10 21 10 14 14 14 14 21 19 21 19 12 20.92 12' }),
    image: _react2.default.createElement('path', { d: 'M20,3H4A1,1,0,0,0,3,4V20a1,1,0,0,0,1,1H20a1,1,0,0,0,1-1V4A1,1,0,0,0,20,3ZM8,6A2,2,0,1,1,6,8,2,2,0,0,1,8,6ZM5,19l4-6,2,2,3-4,5,8Z' }),
    indent: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('polygon', { points: '3 8 3 16 8.33 12 3 8' }),
      _react2.default.createElement('rect', { x: '5', y: '3', width: '16', height: '3' }),
      _react2.default.createElement('rect', { x: '12', y: '8', width: '9', height: '3' }),
      _react2.default.createElement('rect', { x: '12', y: '13', width: '9', height: '3' }),
      _react2.default.createElement('rect', { x: '5', y: '18', width: '16', height: '3' })
    ),
    indent_hanging: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('rect', { x: '3', y: '3', width: '18', height: '3' }),
      _react2.default.createElement('rect', { x: '11', y: '8', width: '10', height: '3' }),
      _react2.default.createElement('rect', { x: '11', y: '13', width: '10', height: '3' }),
      _react2.default.createElement('rect', { x: '11', y: '18', width: '10', height: '3' }),
      _react2.default.createElement('polygon', { points: '3 16 8.33 12 3 8 3 16' })
    ),
    info: _react2.default.createElement('path', { d: 'M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm1,14.85H11V11h2ZM13,9h-2v-2h2Z' }),
    info_outline: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M12,2c-5.486,0 -10,4.514 -10,10c0,5.486 4.514,10 10,10c5.486,0 10,-4.514 10,-10c0,-5.486 -4.514,-10 -10,-10Zm0,18c-4.389,0 -8,-3.611 -8,-8c0,-4.389 3.611,-8 8,-8c4.389,0 8,3.611 8,8c0,4.389 -3.611,8 -8,8l0,0Z', fillRule: 'nonzero' }),
      _react2.default.createElement('rect', { height: '7.253', width: '2', x: '11', y: '9.747' }),
      _react2.default.createElement('rect', { height: '2', width: '2', x: '11', y: '6.747' })
    ),
    italic: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('polygon', { points: '9 3.02 9 5.54 12.02 5.54 12.52 3.04 15.64 3.04 15.14 5.54 18.17 5.54 18.17 3.02 9 3.02' }),
      _react2.default.createElement('polygon', { points: '18.27 5.5 18.78 3 9.4 3 8.9 5.5 12.03 5.5 9.63 17.5 6.5 17.5 6 20 15.38 20 15.88 17.5 12.75 17.5 15.15 5.5 18.27 5.5' })
    ),
    item_add: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M5,5H17v7h2V4a1,1,0,0,0-1-1H4A1,1,0,0,0,3,4V18a1,1,0,0,0,1,1h8V17L5,17Z' }),
      _react2.default.createElement('polygon', { points: '22 17 19 17 19 14 17 14 17 17 14 17 14 19 17 19 17 22 19 22 19 19 22 19 22 17' })
    ),
    item_copy: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M18,17V3a1,1,0,0,0-1-1H3A1,1,0,0,0,2,3V17a1,1,0,0,0,1,1H17A1,1,0,0,0,18,17Zm-2-1H4V4H16Z' }),
      _react2.default.createElement('path', { d: 'M21,7H20V20H6v1a1,1,0,0,0,1,1H21a1,1,0,0,0,1-1V8A1,1,0,0,0,21,7Z' })
    ),
    item_edit: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M21.69,4,20,2.29a1,1,0,0,0-1.41,0L17.18,3.7l3,3.13,1.51-1.41A1,1,0,0,0,21.69,4Z' }),
      _react2.default.createElement('polygon', { points: '8 16 10.97 16 19.17 7.82 16.14 4.68 8 12.97 8 16' }),
      _react2.default.createElement('path', { d: 'M19,19H5V5h5.92l2-2H4A1,1,0,0,0,3,4V20a1,1,0,0,0,1,1H20a1,1,0,0,0,1-1V11l-2,2Z' })
    ),
    item_edit_duplicate: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M20,9.92V20H6v1a1,1,0,0,0,1,1H21a1,1,0,0,0,1-1V8Z' }),
      _react2.default.createElement('path', { d: 'M4.5,18H3a1,1,0,0,1-1-1V15.5H4l.5.5Z' }),
      _react2.default.createElement('path', { d: 'M4,13.67H2V10.92H4ZM4,9.08H2V6.33H4Z' }),
      _react2.default.createElement('path', { d: 'M4,4.5H2V3A1,1,0,0,1,3,2H4.5V4Z' }),
      _react2.default.createElement('path', { d: 'M13.67,4H10.92V2h2.75ZM9.08,4H6.33V2H9.08Z' }),
      _react2.default.createElement('path', { d: 'M21.34,4.17,19.91,2.72a.86.86,0,0,0-1.19,0L17.53,3.91l2.54,2.65,1.27-1.19a.85.85,0,0,0,0-1.2Z' }),
      _react2.default.createElement('polygon', { points: '6.4 15.13 6.4 17.68 8.91 17.68 19.21 7.39 16.65 4.74 6.4 15.13' })
    ),
    item_remove: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M5,5H17v7h2V4a1,1,0,0,0-1-1H4A1,1,0,0,0,3,4V18a1,1,0,0,0,1,1h8V17L5,17Z' }),
      _react2.default.createElement('polygon', { points: '22.04 15.38 20.62 13.96 18 16.59 15.38 13.96 13.96 15.38 16.59 18 13.96 20.62 15.38 22.04 18 19.41 20.62 22.04 22.04 20.62 19.41 18 22.04 15.38' })
    ),
    label_on: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M10.76,3h2.75L20,21H17.36l-1.88-5.44h-7L6.43,21H3.93Zm4,10.6L12,5.66,9.15,13.6Z' })
    ),
    label_off: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('polygon', { points: '12.56 15.58 15.48 15.58 17.36 21 20.03 21 16.61 11.54 12.56 15.58' }),
      _react2.default.createElement('path', { d: 'M20.52,2.06,15.13,7.46,13.51,3H10.76L5.43,17.16,1.92,20.67l1.41,1.41,18.6-18.6ZM12,5.66l1.26,3.63-4,4Z' })
    ),
    legend: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M7 9h11v2H7zM7 2h11v2H7zM7 16h11v2H7zM2.5 0L5 5H0z' }),
      _react2.default.createElement('circle', { cx: '2.5', cy: '17.5', r: '2.5' }),
      _react2.default.createElement('path', { d: 'M0 8h5v5H0z' })
    ),
    level_down: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M20 15L15 10 15 14 7 14 7 5 5 5 5 16 15 16 15 20z' })
    ),
    line_spacing: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('rect', { x: '10', y: '3', width: '11', height: '3' }),
      _react2.default.createElement('rect', { x: '10', y: '8', width: '11', height: '3' }),
      _react2.default.createElement('rect', { x: '10', y: '13', width: '11', height: '3' }),
      _react2.default.createElement('rect', { x: '10', y: '18', width: '11', height: '3' }),
      _react2.default.createElement('polygon', { points: '8 9 5.5 5 3 9 5 9 5 15 3 15 5.5 19 8 15 6 15 6 9 8 9' })
    ),
    link: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M12.71,14.12,10.9,15.93l-.63.63-1.81,1.8a2,2,0,0,1-2.82-2.82L7.3,13.87a5.93,5.93,0,0,1-.57-2.25l-2.51,2.5a4,4,0,0,0,5.66,5.66l4.24-4.24a4,4,0,0,0,0-5.66l-1.41,1.41A2,2,0,0,1,12.71,14.12Z' }),
      _react2.default.createElement('path', { d: 'M14.12,4.22,9.88,8.46a4,4,0,0,0,0,5.66l1.41-1.41a2,2,0,0,1,0-2.83L13.1,8.07l.63-.63,1.81-1.8a2,2,0,0,1,2.82,2.82L16.7,10.13a5.93,5.93,0,0,1,.57,2.25l2.51-2.5a4,4,0,0,0-5.66-5.66Z' })
    ),
    list_left: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('rect', { x: '8', y: '3', width: '13', height: '3' }),
      _react2.default.createElement('rect', { x: '3', y: '3', width: '3', height: '3' }),
      _react2.default.createElement('rect', { x: '3', y: '10', width: '3', height: '3' }),
      _react2.default.createElement('rect', { x: '3', y: '17', width: '3', height: '3' }),
      _react2.default.createElement('rect', { x: '8', y: '10', width: '13', height: '3' }),
      _react2.default.createElement('rect', { x: '8', y: '17', width: '13', height: '3' })
    ),
    list_numbered: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('rect', { x: '8', y: '3', width: '13', height: '3' }),
      _react2.default.createElement('rect', { x: '4', y: '2', width: '1', height: '5' }),
      _react2.default.createElement('rect', { x: '8', y: '10', width: '13', height: '3' }),
      _react2.default.createElement('rect', { x: '8', y: '17', width: '13', height: '3' }),
      _react2.default.createElement('polygon', { points: '3 10 5 10 5 11 3 11 3 14 6 14 6 13 4 13 4 12 6 12 6 9 3 9 3 10' }),
      _react2.default.createElement('polygon', { points: '3 17 5 17 5 18 3 18 3 19 5 19 5 20 3 20 3 21 6 21 6 16 3 16 3 17' })
    ),
    list_right: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('rect', { x: '3', y: '3', width: '13', height: '3' }),
      _react2.default.createElement('rect', { x: '18', y: '3', width: '3', height: '3' }),
      _react2.default.createElement('rect', { x: '18', y: '10', width: '3', height: '3' }),
      _react2.default.createElement('rect', { x: '18', y: '17', width: '3', height: '3' }),
      _react2.default.createElement('rect', { x: '3', y: '10', width: '13', height: '3' }),
      _react2.default.createElement('rect', { x: '3', y: '17', width: '13', height: '3' })
    ),
    locked: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M18 10h-2V6a4 4 0 1 0-8 0v4H6a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V11a1 1 0 0 0-1-1zm-8-4a2 2 0 1 1 4 0v4h-4z' })
    ),
    map_pin: _react2.default.createElement('path', {
      d: 'M12 2a6.77 6.77 0 0 0-6.78 6.79C5.22 14 12 22 12 22s6.78-8 6.78-13.21A6.78 6.78 0 0 0 12 2zm0 9.63a2.9 2.9 0 1 1 2.9-2.9 2.9 2.9 0 0 1-2.9 2.91z',
      fillRule: 'evenodd'
    }),
    margins: _react2.default.createElement('path', { d: 'M22,7V5H19V2H17V5H7V2H5V5H2V7H5V17H2v2H5v3H7V19H17v3h2V19h3V17H19V7ZM17,17H7V7H17Z' }),
    maximize: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M20,3H4A1,1,0,0,0,3,4V20a1,1,0,0,0,1,1H20a1,1,0,0,0,1-1V4A1,1,0,0,0,20,3ZM19,19H5V5H19Z' }),
      _react2.default.createElement('polygon', { points: '11 17 13 17 13 13 17 13 17 11 13 11 13 7 11 7 11 11 7 11 7 13 11 13 11 17' })
    ),
    menu: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('rect', { x: '3', y: '3', width: '18', height: '3' }),
      _react2.default.createElement('rect', { x: '3', y: '10', width: '18', height: '3' }),
      _react2.default.createElement('rect', { x: '3', y: '17', width: '18', height: '3' })
    ),
    microphone: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('rect', { x: '9.14', y: '2.97', width: '5.72', height: '11.18', rx: '2.86', ry: '2.86' }),
      _react2.default.createElement('path', { d: 'M19.08,11.15a1,1,0,1,0-2,0,5.05,5.05,0,1,1-10.11,0,1,1,0,0,0-2,0,7.1,7.1,0,0,0,6.06,7v2a1,1,0,0,0,2,0v-2A7.1,7.1,0,0,0,19.08,11.15Z' })
    ),
    minimize: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M20,3H4A1,1,0,0,0,3,4V20a1,1,0,0,0,1,1H20a1,1,0,0,0,1-1V4A1,1,0,0,0,20,3ZM19,19H5V5H19Z' }),
      _react2.default.createElement('rect', { x: '7', y: '15', width: '10', height: '2' })
    ),
    minus: _react2.default.createElement('rect', { x: '3', y: '11', width: '18', height: '2' }),
    monospace: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M7.85,3.14a2.83,2.83,0,0,0-1.2.65,2.16,2.16,0,0,0-.57,1.09,11.93,11.93,0,0,0-.16,2.4,9.94,9.94,0,0,1-.07,1.48,2.47,2.47,0,0,1-.33,1,1.29,1.29,0,0,1-.56.53,2.61,2.61,0,0,1-1,.2v2.13a2.08,2.08,0,0,1,1.19.35,1.86,1.86,0,0,1,.59,1,10,10,0,0,1,.14,2.12,10,10,0,0,0,.15,2.05,2.25,2.25,0,0,0,.58,1.1,2.56,2.56,0,0,0,1.07.63A6.47,6.47,0,0,0,9.53,20H10V17.89a3.9,3.9,0,0,1-1.23-.12.84.84,0,0,1-.43-.35,1.69,1.69,0,0,1-.14-.81c0-.27,0-.9-.06-1.88a6.71,6.71,0,0,0-.23-1.54,2.83,2.83,0,0,0-.5-1,3.15,3.15,0,0,0-.85-.71,3.77,3.77,0,0,0,.87-.73,2.94,2.94,0,0,0,.47-.9,5.61,5.61,0,0,0,.23-1.43c0-1,.08-1.74.08-2.11a1.63,1.63,0,0,1,.13-.78.82.82,0,0,1,.41-.34A4.39,4.39,0,0,1,10,5.1V3H9.53A6.73,6.73,0,0,0,7.85,3.14Z' }),
      _react2.default.createElement('path', { d: 'M19,10.24a1.4,1.4,0,0,1-.56-.53,2.32,2.32,0,0,1-.32-1,9.94,9.94,0,0,1-.07-1.48,12.75,12.75,0,0,0-.16-2.4,2.32,2.32,0,0,0-.57-1.09,3,3,0,0,0-1.2-.65A6.76,6.76,0,0,0,14.46,3H14V5.1a4.39,4.39,0,0,1,1.25.11.87.87,0,0,1,.41.34,1.77,1.77,0,0,1,.13.78c0,.37,0,1.07.08,2.11a5.2,5.2,0,0,0,.23,1.43,2.92,2.92,0,0,0,.46.9,3.86,3.86,0,0,0,.88.73,3,3,0,0,0-.85.71,2.67,2.67,0,0,0-.5,1,6.2,6.2,0,0,0-.23,1.54c0,1-.06,1.61-.06,1.88a1.69,1.69,0,0,1-.14.81.88.88,0,0,1-.43.35,3.9,3.9,0,0,1-1.23.12V20h.46a6.55,6.55,0,0,0,1.82-.19,2.52,2.52,0,0,0,1.06-.63,2.27,2.27,0,0,0,.59-1.1,10,10,0,0,0,.15-2.05,9.37,9.37,0,0,1,.14-2.12,1.85,1.85,0,0,1,.58-1,2.09,2.09,0,0,1,1.2-.35V10.44A2.68,2.68,0,0,1,19,10.24Z' })
    ),
    more: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('circle', { cx: '3.99', cy: '12', r: '1.96' }),
      _react2.default.createElement('circle', { cx: '11.99', cy: '12', r: '1.96' }),
      _react2.default.createElement('circle', { cx: '19.99', cy: '12', r: '1.96' })
    ),
    mortar_board: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('polygon', { points: '12.36 9.24 6.2 13.18 12 16.89 24.02 9.22 12 1.54 -0.02 9.22 4.83 12.31 10.96 8.39 12.36 9.24' }),
      _react2.default.createElement('polygon', { points: '4.99 14.09 4.99 17.41 12 22 19.01 17.41 19.01 14.09 12 18.65 4.99 14.09' })
    ),
    move: _react2.default.createElement('polygon', { points: '22.05 12 19 8.95 19 11 13 11 13 5 15.05 5 12 1.95 8.95 5 11 5 11 11 5 11 5 8.95 1.95 12 5 15.05 5 13 11 13 11 19 8.95 19 12 22.05 15.05 19 13 19 13 13 19 13 19 15.05 22.05 12', fillRule: 'evenodd' }),
    not: _react2.default.createElement('path', { d: 'M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2ZM4,12A8,8,0,0,1,16.82,5.66l-11.37,11A8,8,0,0,1,4,12Zm8,8A8,8,0,0,1,6.79,18.1l11.45-11A8,8,0,0,1,12,20Z' }),
    outdent: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('polygon', { points: '8 8 2.67 12 8 16 8 8' }),
      _react2.default.createElement('rect', { x: '5', y: '3', width: '16', height: '3' }),
      _react2.default.createElement('rect', { x: '12', y: '8', width: '9', height: '3' }),
      _react2.default.createElement('rect', { x: '12', y: '13', width: '9', height: '3' }),
      _react2.default.createElement('rect', { x: '5', y: '18', width: '16', height: '3' })
    ),
    overview: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M15.28 11.67L19.69 4H4.31l4.41 7.67C4.73 12.29 2 14 2 16.21 2 18.94 6.3 21 12 21s10-2.06 10-4.79c0-2.21-2.73-3.92-6.72-4.54zM12 19.54c-5 0-8.54-1.76-8.54-3.33 0-1.3 2.39-2.72 6-3.18L12 17.37 14.5 13c3.65.46 6 1.88 6 3.18.04 1.6-3.5 3.36-8.5 3.36z' })
    ),
    page_break: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('polygon', { points: '19 9 19 2 17 2 17 7 7 7 7 2 5 2 5 9 19 9' }),
      _react2.default.createElement('polygon', { points: '5 15 5 22 7 22 7 17 17 17 17 22 19 22 19 15 5 15' }),
      _react2.default.createElement('rect', { x: '2', y: '11', width: '20', height: '2' })
    ),
    panel_collapse: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M21.04 4.41L19.63 3l-3.64 3.64-2.95-2.89V11h7.38l-3.01-2.96zM6.67 15.96l-3.63 3.63L4.46 21l3.64-3.64 2.94 2.89V13H3.66z' })
    ),
    panel_expand: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M13.04 9.59L14.45 11l3.64-3.64 2.95 2.89V3h-7.38l3.01 2.96zM7.41 18.04l3.63-3.63L9.62 13l-3.64 3.64-2.94-2.89V21h7.38z' })
    ),
    pause: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z' }),
      _react2.default.createElement('rect', { x: '9', y: '8', width: '2', height: '8' }),
      _react2.default.createElement('rect', { x: '13', y: '8', width: '2', height: '8' })
    ),
    pause_solo: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('rect', { x: '5.04', y: '3', width: '5', height: '18' }),
      _react2.default.createElement('rect', { x: '14.04', y: '3', width: '5', height: '18' })
    ),
    person: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M12,12.92c2.6,0,4.61-3,4.61-5.84S15.15,2,12,2,7.37,4.25,7.37,7.08,9.39,12.92,12,12.92Z' }),
      _react2.default.createElement('path', { d: 'M12,15.54c-5.31,0-9.65-4.2-9.93,5.41a1,1,0,0,0,1,1H20.92a1,1,0,0,0,1-1C21.63,11.37,17.29,15.54,12,15.54Z' })
    ),
    person_group: _react2.default.createElement('path', { fillRule: 'evenodd', d: 'M1.12 18.27c0-7.51 3.26-4.81 7-4.81s7-2.67 7 4.81a.72.72 0 01-.7.73H1.82a.72.72 0 01-.7-.73zm15.32-4.56c3.56 0 6.56-2.71 6.59 4.6v.01a.67.67 0 01-.66.68h-6.46a1.07 1.07 0 00.55-1 14.956 14.956 0 00-.78-4.29zm.42-8c1.81 0 2.64 1.29 2.64 2.93 0 1.62-1.15 3.34-2.64 3.34-1.49 0-2.64-1.72-2.64-3.34 0-1.62.83-2.93 2.64-2.93zM8.12 3.88c2.25 0 3.25 1.61 3.25 3.61 0 2-1.42 4.12-3.25 4.12S4.87 9.49 4.87 7.49s1-3.61 3.25-3.61z' }),
    play: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z' }),
      _react2.default.createElement('polygon', { points: '9 17.03 16.98 12.01 9 7.03 9 17.03', fillRule: 'evenodd' })
    ),
    play_solo: _react2.default.createElement('polygon', { points: '6.04 21 20.36 11.99 6.04 3.06 6.04 21', fillRule: 'evenodd' }),
    plus: _react2.default.createElement('polygon', { points: '21 11 13 11 13 3 11 3 11 11 3 11 3 13 11 13 11 21 13 21 13 13 21 13 21 11' }),
    pointer_outline: _react2.default.createElement('path', { d: 'M8.95,6.56l6.92,6.34L13,13.57l2.28,5.1-1.65.71-2.28-5.22L9,16,8.95,6.56M6.92,2,7,20l3.51-2.73,2,4.69,5.34-2.31L15.81,15,20,14,6.92,2Z' }),
    pointer: _react2.default.createElement('path', { d: 'M6.92,2,7,20l3.51-2.73,2,4.69,5.34-2.31L15.81,15,20,14,6.92,2Z' }),
    print: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M21,8H3A1,1,0,0,0,2,9v8a1,1,0,0,0,1,1H5v4H19V18h2a1,1,0,0,0,1-1V9A1,1,0,0,0,21,8ZM6,12H4V10H6Zm11,6v2H7V16H17Z' }),
      _react2.default.createElement('rect', { x: '5.96', y: '2.02', width: '12.04', height: '4.98' })
    ),
    redo: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M7.86,13a5,5,0,0,1,5-5v3l5.33-4L12.83,3V6a7,7,0,0,0,0,14H18V18H12.83A5,5,0,0,1,7.86,13Z' })
    ),
    replay: _react2.default.createElement('path', { d: 'M20,12a8,8,0,1,1-2.59-5.87L14.57,9h7V2L18.86,4.73A10,10,0,1,0,22,12Z', fillRule: 'evenodd' }),
    refresh: _react2.default.createElement('path', {
      d: 'M4 12a8 8 0 0 1 13.44-5.85L14.57 9h7V2l-2.71 2.73A10 10 0 0 0 2 12zM22 12a10 10 0 0 1-16.84 7.3L2.48 22v-7h7l-2.87 2.89A8 8 0 0 0 20 12z',
      fillRule: 'evenodd'
    }),
    rotate_x: _react2.default.createElement('path', { d: 'M12.08,1.85C9.36,1.85,7.23,5.24,6.76,10L3.69,10l4.13,5.13L12,10,8.78,10c.42-3.62,1.93-6.13,3.3-6.13,1.61,0,3.42,3.48,3.42,8.13s-1.8,8.13-3.42,8.13c-.57,0-1.26-.18-2-1.53a1,1,0,1,0-1.76.94,4.19,4.19,0,0,0,3.74,2.58c3.09,0,5.42-4.36,5.42-10.13S15.17,1.85,12.08,1.85Z' }),
    rotate_y: _react2.default.createElement('path', { d: 'M12,6.58C6.22,6.58,1.86,8.91,1.86,12c0,2.72,3.39,4.85,8.16,5.32l0,3.07,5.13-4.13L10,12l0,3.25c-3.62-.42-6.13-1.93-6.13-3.3,0-1.61,3.48-3.42,8.13-3.42s8.13,1.8,8.13,3.42c0,.57-.18,1.26-1.53,2a1,1,0,0,0,.94,1.76A4.19,4.19,0,0,0,22.13,12C22.13,8.91,17.77,6.58,12,6.58Z' }),
    search: _react2.default.createElement('path', { d: 'M16.35,14.94a8.08,8.08,0,1,0-1.43,1.4l5.37,5.37,1.41-1.41ZM10,16a6,6,0,1,1,6-6A6,6,0,0,1,10,16Z' }),
    send: _react2.default.createElement('path', { d: 'M2,9.6427002 L21.9999,3.0003 L18.9999,20.0003 L11.5999,15.5623 L8.9999,19.0003 L7.7569,13.1823 L2,9.6427002 Z M17.5659,16.7773 L19.4619,5.7743 L6.6469,10.1663 L9.5259,11.9193 L16.9389,7.8393 L17.2859,7.9583 L12.6729,13.8853 L17.5659,16.7773 Z' }),
    spreadsheet: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M18,4V20H6V4H18m1-2H5A1,1,0,0,0,4,3V21a1,1,0,0,0,1,1H19a1,1,0,0,0,1-1V3a1,1,0,0,0-1-1Z' }),
      _react2.default.createElement('path', { d: 'M8,7V17h8V7Zm6,2v2H10V9Zm-4,6V13h4v2Z' })
    ),
    stop: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z' }),
      _react2.default.createElement('rect', { x: '8', y: '8', width: '8', height: '8' })
    ),
    stop_solo: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('rect', { x: '3.04', y: '3', width: '18', height: '18' })
    ),
    strikethrough: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M12.51,9.65c-1.42-.57-2.61-1-2.61-2.22s1-1.8,2.46-1.8A5.47,5.47,0,0,1,16,7l1.71-2.12a7.63,7.63,0,0,0-5.33-2.19c-3.4,0-5.84,2.15-5.84,4.9a4.4,4.4,0,0,0,.47,2Z' }),
      _react2.default.createElement('path', { d: 'M21,11.32H3V13h8.82l.4.17c1.52.64,2.56,1,2.56,2.3s-.94,2-2.72,2a6.7,6.7,0,0,1-4.32-1.87L5.8,17.86A9,9,0,0,0,12,20.33c3.91,0,6.22-2.35,6.22-5.13A4.81,4.81,0,0,0,17.71,13H21Z' })
    ),
    subscript: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('polygon', { points: '13.45 3.18 9.04 7.59 4.63 3.18 3.22 4.59 7.63 9 3.22 13.41 4.63 14.82 9.04 10.41 13.45 14.82 14.86 13.41 10.46 9 14.86 4.59 13.45 3.18' }),
      _react2.default.createElement('polygon', { points: '20 17 20 13 16 13 16 14 19 14 19 16 16 16 16 20 20 20 20 19 17 19 17 17 20 17' })
    ),
    superscript: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('polygon', { points: '14.86 9.59 13.45 8.18 9.04 12.59 4.63 8.18 3.22 9.59 7.63 14 3.22 18.41 4.63 19.82 9.04 15.41 13.45 19.82 14.86 18.41 10.46 14 14.86 9.59' }),
      _react2.default.createElement('polygon', { points: '20 7 20 3 16 3 16 4 19 4 19 6 16 6 16 10 20 10 20 9 17 9 17 7 20 7' })
    ),
    text_size: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('polygon', { points: '21 4 10 4 10 7 14 7 14 20 17 20 17 7 21 7 21 4', fillRule: 'evenodd' }),
      _react2.default.createElement('polygon', { points: '3 14 6 14 6 20 9 20 9 14 12 14 12 11 3 11 3 14', fillRule: 'evenodd' })
    ),
    text_treatment: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M13.16,20h3L11,4H7.62L2.4,20H5.3l1.25-4.34h5.37Zm-6-6.56,2-7.23h.09l2,7.23Z' }),
      _react2.default.createElement('polygon', { points: '13.41 4.02 14.07 6.03 16.09 4.01 13.41 4.02' }),
      _react2.default.createElement('polygon', { points: '16.98 5.79 14.72 8.05 15.39 10.1 17.65 7.84 16.98 5.79' }),
      _react2.default.createElement('polygon', { points: '18.3 9.86 16.05 12.12 16.71 14.17 18.97 11.91 18.3 9.86' }),
      _react2.default.createElement('polygon', { points: '19.63 13.93 17.37 16.19 18.03 18.24 20.29 15.97 19.63 13.93' }),
      _react2.default.createElement('polygon', { points: '20.95 18 18.94 20 21.59 19.99 20.95 18' })
    ),
    thumbs_down: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M22.08,13.11a1,1,0,0,1-1,1.12H14s1,2.8,1.62,4.59c.53,1.58-.23,2.93-1.31,1.85C12.7,19.12,8.5,14.59,8.5,14.59A1.71,1.71,0,0,1,8,13.36V3.53a.38.38,0,0,1,.38-.38H18.62a1.74,1.74,0,0,1,1.61,1.07s1.86,6.59,1.86,6.82Z' }),
      _react2.default.createElement('rect', { x: '3', y: '3.22', width: '3', height: '11' })
    ),
    thumbs_up: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M22.08,11.1a1,1,0,0,0-1-1.12H14s1-2.8,1.62-4.59c.53-1.58-.23-2.93-1.31-1.85C12.7,5.1,8.5,9.62,8.5,9.62A1.71,1.71,0,0,0,8,10.86v9.83a.38.38,0,0,0,.38.38H18.62A1.74,1.74,0,0,0,20.23,20s1.86-6.59,1.86-6.82Z' }),
      _react2.default.createElement('rect', { x: '3', y: '10', width: '3', height: '11' })
    ),
    tools: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M20.74,6.41a1,1,0,0,0,0-1.41L19,3.29a1,1,0,0,0-1.41,0L16.22,4.7l3,3.13Z' }),
      _react2.default.createElement('polygon', { points: '3.04 17.98 3.04 21 6.01 21 10.9 16.12 7.87 13.09 3.04 17.98' }),
      _react2.default.createElement('polygon', { points: '18.21 8.82 15.18 5.68 13.05 7.84 16.12 10.91 18.21 8.82' }),
      _react2.default.createElement('path', { d: 'M10.55,7.47A3.75,3.75,0,0,0,5.71,3.26L7.14,4.68A1.74,1.74,0,1,1,4.68,7.14L3.26,5.72a3.75,3.75,0,0,0,4.21,4.84l9.72,9.72a2.18,2.18,0,0,0,3.09-3.09Zm8.65,11.74a.76.76,0,1,1,0-1.08A.76.76,0,0,1,19.21,19.21Z' })
    ),
    trash: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M6,21a1,1,0,0,0,1,1H17a1,1,0,0,0,1-1V7H6Z' }),
      _react2.default.createElement('path', { d: 'M18,3H14V2H9.92V3H6A1,1,0,0,0,5,4V6H19V4A1,1,0,0,0,18,3Z' })
    ),
    trending: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M21.908,9.6l-8.15,7.853l-3.921,-3.853l-1.916,-1.88l-5.986,5.986l-1.865,-1.865l7.833,-7.833l3.781,3.71l2.092,2.055l6.302,-6.072l1.83,1.899Z', id: 'Path' }),
      _react2.default.createElement('path', { d: 'M16.035,5.697l7.912,0l0,7.912l-7.912,-7.912Z', id: 'Rectangle' })
    ),
    upload: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('polygon', { points: '19 14 19 18 5 18 5 14 3 14 3 18 3 20 5.5 20 19.5 20 21 20 21 18 21 14 19 14', fillRule: 'evenodd' }),
      _react2.default.createElement('polygon', { points: '11 15 13 15 13 8 16 8 12 4 8 8 11 8 11 15', fillRule: 'evenodd' })
    ),
    underline: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('rect', { x: '5.04', y: '18', width: '13.95', height: '2' }),
      _react2.default.createElement('path', { d: 'M12,16.07q3.24,0,4.38-2.07A6.73,6.73,0,0,0,17,10.83V3H14.35v7.83a4.61,4.61,0,0,1-.3,1.92A2,2,0,0,1,12,13.82,2,2,0,0,1,10,12.75a4.61,4.61,0,0,1-.3-1.92V3H7v7.83A6.73,6.73,0,0,0,7.62,14Q8.78,16.07,12,16.07Z' })
    ),
    undo: _react2.default.createElement('path', { d: 'M11.17,6V3L5.84,7l5.33,4V8a5,5,0,0,1,0,10H6v2h5.17a7,7,0,0,0,0-14Z' }),
    unlink: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M12,14.83,8.46,18.36a2,2,0,0,1-2.82-2.82L9.17,12,7.76,10.59,4.22,14.12a4,4,0,0,0,5.66,5.66l3.53-3.54Z' }),
      _react2.default.createElement('path', { d: 'M14.12,4.22,10.59,7.76,12,9.17l3.54-3.53a2,2,0,0,1,2.82,2.82L14.83,12l1.41,1.41,3.54-3.53a4,4,0,0,0-5.66-5.66Z' }),
      _react2.default.createElement('path', { d: 'M5.28,5.28a.51.51,0,0,0,0,.71L7.4,8.11a.5.5,0,0,0,.71-.71L6,5.28A.51.51,0,0,0,5.28,5.28Z' }),
      _react2.default.createElement('path', { d: 'M9.53,6.7a.51.51,0,0,0,.14-.36V3.51a.5.5,0,0,0-.5-.5.51.51,0,0,0-.5.5V6.34a.5.5,0,0,0,.5.5A.52.52,0,0,0,9.53,6.7Z' }),
      _react2.default.createElement('path', { d: 'M3.51,8.67a.51.51,0,0,0-.5.5.5.5,0,0,0,.5.5H6.34a.51.51,0,0,0,.36-.14.52.52,0,0,0,.14-.36.5.5,0,0,0-.5-.5Z' }),
      _react2.default.createElement('path', { d: 'M15.89,15.89a.5.5,0,0,0,0,.71L18,18.72a.5.5,0,1,0,.71-.71L16.6,15.89A.5.5,0,0,0,15.89,15.89Z' }),
      _react2.default.createElement('path', { d: 'M17.66,14.33a.5.5,0,0,0-.5.5.5.5,0,0,0,.5.5h2.83a.51.51,0,0,0,.35-.15.49.49,0,0,0,.15-.35.5.5,0,0,0-.5-.5Z' }),
      _react2.default.createElement('path', { d: 'M14.33,17.66v2.83a.5.5,0,0,0,.5.5.49.49,0,0,0,.35-.15.51.51,0,0,0,.15-.35V17.66a.5.5,0,0,0-.5-.5A.5.5,0,0,0,14.33,17.66Z' })
    ),
    unlock: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M18,10H10V6a2,2,0,1,1,4,0V7h2V6A4,4,0,1,0,8,6v4H6a1,1,0,0,0-1,1V21a1,1,0,0,0,1,1H18a1,1,0,0,0,1-1V11A1,1,0,0,0,18,10Z' })
    ),
    video: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('polygon', { points: '9 7.63 9 16.37 15.97 11.98 9 7.63' }),
      _react2.default.createElement('path', { d: 'M20,3H4A1,1,0,0,0,3,4V20a1,1,0,0,0,1,1H20a1,1,0,0,0,1-1V4A1,1,0,0,0,20,3ZM19,19H5V5H19Z' })
    ),
    writing_edit: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M18,4.06l.88-.88a.62.62,0,0,1,.88,0l1,1.07a.62.62,0,0,1,0,.88L19.87,6', fillRule: 'evenodd' }),
      _react2.default.createElement('polygon', { points: '14.14 11.71 12.29 11.71 12.29 9.83 17.36 4.67 19.25 6.62 14.14 11.71', fillRule: 'evenodd' }),
      _react2.default.createElement('path', { d: 'M4,21l-.37-1.33c.15,0,3.24-.54,4.21-3l-.17,0c-1.27-.33-2.21-1.43-2.56-3.37s.07-2.78.45-3.12a1.56,1.56,0,0,1,1.67-.23c1,.39,2.18,1.78,2.4,4.41a5.14,5.14,0,0,1,0,.65A8.32,8.32,0,0,0,12.35,13h1.84a10.5,10.5,0,0,1-4.77,3.44C8.61,19.26,5.65,20.49,4,21ZM6.6,11.11a.1.1,0,0,0-.07,0c-.1.09-.31.57,0,1.72.35,1.37.81,2.06,1.55,2.26l.12,0a1.53,1.53,0,0,0,.09-.75c-.17-2-1-3-1.53-3.24A.46.46,0,0,0,6.6,11.11Z' })
    ),
    word_count: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M13.421,9.4755 L13.014,8.1245 C12.66,6.9595 12.306,5.6935 11.97,4.4775 L11.9,4.4775 C11.581,5.7105 11.245,6.9595 10.874,8.1245 L10.467,9.4755 L13.421,9.4755 Z M13.881,11.0115 L10.007,11.0115 L9.105,14.0005 L7,14.0005 L10.785,2.9585 L13.191,2.9585 L16.958,14.0005 L14.783,14.0005 L13.881,11.0115 Z M5,21 L5,16 L6,16 L6,21 L5,21 Z M10,17 L10,16 L13,16 L13,19 L11,19 L11,20 L13,20 L13,21 L10,21 L10,18 L12,18 L12,17 L10,17 Z M17,17 L17,16 L20,16 L20,21 L17,21 L17,20 L19,20 L19,19 L17,19 L17,18 L19,18 L19,17 L17,17 Z', id: 'icon' })
    ),
    x: _react2.default.createElement('polygon', { points: '19.82 5.59 18.41 4.18 12 10.59 5.59 4.18 4.18 5.59 10.59 12 4.18 18.41 5.59 19.82 12 13.41 18.41 19.82 19.82 18.41 13.41 12 19.82 5.59' }),
    zoom_in: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M10,1.92a8,8,0,1,0,4.88,14.42l5.37,5.37,1.41-1.41-5.35-5.35A8,8,0,0,0,10,1.92ZM10,16a6,6,0,1,1,6-6,6,6,0,0,1-6,6Z' }),
      _react2.default.createElement('polygon', { points: '11 6.13 8.92 6.13 8.92 8.92 6.13 8.92 6.13 11 8.92 11 8.92 13.79 11 13.79 11 11 13.79 11 13.79 8.92 11 8.92 11 6.13 11 6.13' })
    ),
    zoom_out: _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M10,1.92a8,8,0,1,0,4.88,14.42l5.37,5.37,1.41-1.41-5.35-5.35A8,8,0,0,0,10,1.92ZM10,16a6,6,0,1,1,6-6,6,6,0,0,1-6,6Z' }),
      _react2.default.createElement('polygon', { points: '13.79 8.92 6.13 8.92 6.13 11 13.79 11 13.79 8.92 13.79 8.92' })
    )
  };

  // Convenience Duplicates
  icons.lock = icons.locked;
  icons.sync = icons.refresh;

  var MLIcon = function MLIcon(props) {
    var ariaLabelledBy = void 0;
    var titleId = void 0;
    var descId = void 0;

    var type = props.type,
        title = props.title,
        desc = props.desc,
        role = props.role,
        ariaHidden = props.ariaHidden,
        width = props.width,
        height = props.height,
        viewBox = props.viewBox,
        scale = props.scale,
        fill = props.fill,
        hidden = props.hidden,
        focusable = props.svgFocusable;


    // Return predictable className if none set
    var className = props.className !== '' ? props.className : type + 'Icon';

    if (title !== '') {
      ariaLabelledBy = '' + title;
    }

    if (desc !== '') {
      ariaLabelledBy += ' ' + desc;
    }

    if (hidden) {
      return null;
    }

    var svgProps = {
      className: className, width: width, height: height, viewBox: viewBox, role: role, fill: fill, focusable: focusable
    };

    return _react2.default.createElement(
      'svg',
      _extends({}, svgProps, {
        'aria-labelledby': ariaLabelledBy,
        'aria-hidden': ariaHidden
      }),
      title ? _react2.default.createElement(
        'title',
        { id: titleId },
        title
      ) : null,
      desc ? _react2.default.createElement(
        'desc',
        { id: descId },
        desc
      ) : null,
      _react2.default.createElement(
        'g',
        { transform: 'scale( ' + scale + ' )' },
        icons[type]
      )
    );
  };

  MLIcon.defaultProps = {
    className: '',
    width: '24',
    height: '24',
    viewBox: '0 0 24 24',
    scale: 1,
    fill: '#ffffff',
    role: 'img',
    title: '',
    desc: '',
    hidden: false,
    svgFocusable: false,
    ariaHidden: undefined
  };
  MLIcon.listIcons = Object.keys(icons);

  MLIcon.propTypes = {
    type: _propTypes2.default.string.isRequired,
    title: _propTypes2.default.string,
    desc: _propTypes2.default.string,
    className: _propTypes2.default.string,
    fill: _propTypes2.default.string,
    role: _propTypes2.default.string,
    width: _propTypes2.default.string,
    height: _propTypes2.default.string,
    viewBox: _propTypes2.default.string,
    scale: _propTypes2.default.number,
    hidden: _propTypes2.default.bool,
    svgFocusable: _propTypes2.default.bool,
    ariaHidden: _propTypes2.default.bool
  };

  exports.default = MLIcon;
});